//eslint-disable-next-line
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import * as routes from "routes";
import Loader from "component/Loader";
import store, { persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { ENV_VAR } from "util/Constant";
import { getEnvVariableValue } from "util/CommonUtil";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Page404 = React.lazy(() => import("./view/Page404"));
const PageLogin = React.lazy(() => import("./view/PageLogin"));
const PageSignup = React.lazy(() => import("./view/PageSignup"));
const PageForgotPassword = React.lazy(() => import("./view/PageForgotPassword"));
const PagePasswordReset = React.lazy(() => import("./view/PagePasswordReset"));
const PageVerifyOTP = React.lazy(() => import("./view/PageVerifyOTP"));
const PageLoading = React.lazy(() => import("./view/PageLoading"));
const PageUploadPDF = React.lazy(() => import("./view/PageUploadPDF/PageUploadPDF"));
const PageRebateAnalysis = React.lazy(() => import("./view/PageRebateAnalysis/PageRebateAnalysis"));
const PageUnauthorized = React.lazy(() => import("./view/PageUnauthorized"));

/* eslint-disable */

function App(props: any) {
  // Generate token CSS classes on mount

  const basePath = props.isHost
    ? props.basePath // when loaded inside host
    : routes.linkBasePath; // standalone mode

  return (
    <Provider store={store}>
      <Router basename={basePath}>
        {getEnvVariableValue(ENV_VAR.VITE_SHOULD_PERSIST) === "Y" ? (
          <RoutersWithPersist {...props} />
        ) : (
          <Routers {...props} />
        )}
      </Router>
    </Provider>
  );
}

function Routers(props: any) {
  const containerId = getEnvVariableValue("VITE_REMOTE_NAME") || "synthia-admin";

  const withRouteEnv = (Comp: any, extraProps: any = {}) =>
    React.createElement(Comp as any, {
      // pass through all props coming into Routers so every route
      // gets the same environment (isHost, remoteName, etc.)
      ...props,
      ...extraProps,
    });

  return (
    <React.Suspense fallback={<Loader />}>
      <Routes>
        <Route path="*" element={withRouteEnv(Page404)} />
        <Route
          path={routes.linkPageBase}
          element={withRouteEnv(() => (
            <Navigate to={routes.linkAuthRoute + routes.linkPageUploadAudio} replace />
          ))}
        />
        <Route path={routes.linkPageLogin} element={withRouteEnv(PageLogin)} />
        <Route path={routes.linkPageSignup} element={withRouteEnv(PageSignup)} />
        <Route path={routes.linkPageVerifyOTP} element={withRouteEnv(PageVerifyOTP)} />
        <Route path={routes.linkPageForgotPassword} element={withRouteEnv(PageForgotPassword)} />
        <Route path={routes.linkPagePasswordReset} element={withRouteEnv(PagePasswordReset)} />
        <Route path={routes.linkPageLoading} element={withRouteEnv(PageLoading)} />
        <Route path={routes.linkPageUnauthorized} element={withRouteEnv(PageUnauthorized)} />
        <Route path={`${routes.linkAuthRoute}/*`} element={withRouteEnv(DefaultLayout)} />
      </Routes>
    </React.Suspense>
  );
}

function RoutersWithPersist(props: any) {
  return (
    <PersistGate persistor={persistor}>
      <Routers {...props} />
    </PersistGate>
  );
}

export default App;
